'use client';
import * as React from 'react';
import { useAudioTranscriptionFeature } from '@audio-transcription/ui/AudioTranscriptionProvider';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@core/ui/primitives/tooltip';
import { Button } from '@/core/ui/primitives/button';
interface TriggerButtonProps {
  className?: string;
}
export function AudioTranscriptionTriggerButton({ className = '' }: TriggerButtonProps) {
  const { isAvailable, state, toggle, start } = useAudioTranscriptionFeature();
  const [isMac, setIsMac] = React.useState<boolean | null>(null);
  React.useEffect(() => {
    if (typeof navigator === 'undefined') return;
    setIsMac(navigator.platform.toUpperCase().includes('MAC'));
  }, []);
  if (!isAvailable) {
    return null;
  }
  const modifierLabel = isMac === null ? '⌘/Ctrl' : isMac ? '⌘' : 'Ctrl';
  const altLabel = isMac === null ? '⌥/Alt' : isMac ? '⌥' : 'Alt';
  const shortcutTitle = isMac === null ? '⌘/Ctrl + ⌥/Alt + R' : isMac ? '⌘ ⌥ R' : 'Ctrl + Alt + R';
  const isRecording = state === 'recording';
  const handleClick = () => {
    if (state === 'idle') {
      void start();
      return;
    }
    if (state === 'recording') {
      toggle();
      return;
    }
    toggle();
  };
  return (
    <TooltipProvider>
      <Tooltip delayDuration={60}>
        <TooltipTrigger asChild>
          <Button
            type='button'
            variant='ghost'
            size='icon'
            onClick={handleClick}
            className={`${isRecording ? 'text-red-600 dark:text-red-300' : ''} ${className}`}
            aria-label={`Transcribe (${shortcutTitle})`}>
            <span className='relative inline-flex h-4 w-4 items-center justify-center'>
              <svg className='h-4 w-4' aria-hidden='true' focusable='false'>
                <use href='/app-icons.svg#fas-microphone' />
              </svg>
              {isRecording ? (
                <span className='absolute -right-1 -top-1 inline-flex h-2 w-2 rounded-full bg-red-500 ring-2 ring-white dark:ring-gray-900' />
              ) : null}
            </span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>Transcribe ({shortcutTitle})</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
